<template>
    <SimpleModal
        v-if="showModal"
        :show-close-button="false"
        @close="$emit('close')"
    >
        <template v-slot:header>
            <h2>Let Agreed</h2>
        </template>
        <template v-slot:body>
            <p>
                <strong>Your advert will be visible for another {{ ad.let_agreed_days }} days</strong>
            </p>
        </template>
        <template v-slot:footer>
            <div class="d-flex justify-content-between">
                <button
                    type="button"
                    class="btn btn--transparent-outlined"
                    @click.prevent="onCancel"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    class="btn btn--secondary"
                    @click.prevent="onLetAgreed"
                >
                    Let Agreed
                </button>
            </div>
        </template>
    </SimpleModal>
</template>

<script>
import SimpleModal from '@components/partials/modal/SimpleModal.vue';
import { mapState } from 'vuex';

export default {
    $_veeValidate: {
        validator: 'new', // give me my own validator scope.
    },
    components: {
        SimpleModal,
    },
    props: {
        showModal: {
            type: Boolean,
            required: true,
        },
        ad: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            formData: {
                slug: this.ad.slug,
            },
        };
    },
    computed: {
        ...mapState(['pageState']),
    },
    updated() {
        if (this.showModal) {
            this.formData = {
                slug: this.ad.slug,
            };
        }
        this.$validator.reset();
    },
    methods: {
        onLetAgreed() {
            this.$validator.validate().then((valid) => {
                if (valid) {
                    this.$emit('let-agreed', this.formData);
                    this.$emit('close');
                }
            });
        },
        onCancel() {
            this.$emit('close');
        },
    },
};
</script>
